import React from 'react';
import cx from 'classnames';

const Fa = ({ i, style, mt = 0, className, onClick, ...props }) => (
  <i
    {...props}
    onClick={onClick}
    style={{ marginTop: mt, cursor: onClick ? 'pointer' : undefined, ...style }}
    className={cx('fa', `fa-${i}`, className)}
  />
);

export default Fa;